import * as Yup from 'yup';

const editProfileSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(1)
    .max(100)
    .required(),
  name: Yup.string()
    .min(1)
    .max(100)
    .required(),
  phone: Yup.string()
    .min(10)
    .max(15)
    .matches(/^[+]/)
    .required(),
  email: Yup.string()
    .min(1)
    .max(100)
    .email()
    .required(),
  jobTitle: Yup.string()
    .min(1)
    .max(100)
    .required(),
});

export { editProfileSchema };
